import {useState, useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {selectEventHasRsvp} from '../reducers/eventDetails';
import {InvitationLink} from './InvitationLink';

require('intersection-observer');

export const StickyRSVP = () => {
  const [inverted, setInverted] = useState(false);
  const intersectionCallback = (entries) => {
    const [entry] = entries;
    setInverted(entry.isIntersecting);
  };

  const intersectionOptions = {
    root: null,
    rootMargin: '-50px',
    threshold: 0,
  };

  useEffect(() => {
    const footer = document.getElementById('footer');
    if (footer) {
      const observer = new IntersectionObserver(intersectionCallback, intersectionOptions);
      observer.observe(footer);
      return () => {
        observer.unobserve(footer);
      };
    }
  }, []);

  const isHost = useSelector((state) => state.user?.isHost ?? false);

  const eventHasRsvp = useSelector(selectEventHasRsvp);
  const hasRsvpd = useSelector((state) => state.rsvp?.hasRsvpd);
  const location = useLocation();
  if (isHost || !eventHasRsvp || hasRsvpd) return null;
  if (location.pathname.indexOf('/rsvp') === 0 || location.pathname.indexOf('/donate') === 0) {
    return null;
  }
  let extraClasses = '';
  if (location.pathname.indexOf('/messages/') === 0)
    extraClasses += ' sticky-button__extra-margin-for-text-entry';
  return (
    <InvitationLink to="/rsvp">
      <button
        id="id_sticky_rsvp_button"
        data-qa-id="sticky-rsvp-button"
        className={`primary-button large sticky-button ${
          inverted ? 'sticky-button__inverted' : ''
        }${extraClasses}`}
      >
        RSVP
      </button>
    </InvitationLink>
  );
};

export const animateRSVPButton = () => {
  const rsvpButton = document.getElementById('id_sticky_rsvp_button');
  if (rsvpButton) {
    const removeRsvpGateClass = () => {
      rsvpButton.classList.remove('rsvp_gate');
      rsvpButton.innerText = 'RSVP';
      rsvpButton.classList.add('rsvp_gate_shrink');
      setTimeout(() => {
        rsvpButton.classList.remove('rsvp_gate_shrink');
      }, 300);
      window.removeEventListener('scroll', removeRsvpGateClass);
    };

    rsvpButton?.classList.add('rsvp_gate');
    window.addEventListener('scroll', removeRsvpGateClass);
    setTimeout(() => {
      rsvpButton.innerHTML =
        '<span>RSVP required</span><span class=\'sticky_rsvp_button_span\'>&nbsp;</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="17.709" viewBox="0 0 24 17.709"><defs><style>.a{fill:#fff;}</style></defs><path class="a" d="M46.105,991.214a1.489,1.489,0,0,0-.36-.913l-7.084-7.527a1.521,1.521,0,0,0-1.937-.111,1.383,1.383,0,0,0,.014,1.937l4.981,5.285H23.434a1.328,1.328,0,0,0,0,2.656H41.72l-4.981,5.285a1.463,1.463,0,0,0-.014,1.937,1.5,1.5,0,0,0,1.937-.111l7.084-7.527A1.277,1.277,0,0,0,46.105,991.214Z" transform="translate(-22.105 -982.362)"/></svg>';
    }, 100);
  }
};
